import { isEmpty } from "lodash";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
// import CustomerView from '.'
import {
  fetchCurrentState,
  getTripData,
} from "../../redux/features/customerViewSlice";
import { postTripDataAsync } from "../../redux/services/apiCalls";
import Loader from "../common/Loader";
// import { testObj } from '../../test1'

export default function RedirectPage() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const tripStateData = useSelector(fetchCurrentState);
  const navigate = useNavigate();

  let isLoading = true;

  useEffect(() => {
    const storedTripId = localStorage.getItem("tripId");
    const currentParams = Object.fromEntries([...searchParams]);
    var { tripId } = currentParams;

    if (isEmpty(tripId) && storedTripId) {
      tripId = storedTripId;
    }

    // -------------Use For API------------------

    // DEV ENV TOKEN
    var tokenStr =
      "0fa77c70-0561-46d2unravel@123-9ab5-9b3aa054aebe-customer@unravelapp.com";

    // PROD ENV Token
    // var tokenStr =
    //   "0c7783c9-6478-4781unravel@123-8b91-d7a190ceca34-customer@unravelapp.com";

    var host = window.location.hostname;
    if (host === "trip.unravelapp.com" || host === "trips.unravelapp.com") {
      // PROD ENV Token
      var tokenStr =
        "0c7783c9-6478-4781unravel@123-8b91-d7a190ceca34-customer@unravelapp.com";
    }

    const body = {
      item_id: tripId,
    };

    dispatch(
      postTripDataAsync(`api/v1/get-items?item_id=${tripId}`, body, {
        headers: { token: `${tokenStr}` },
      })
    );

    // ------------Use for local json data---------
    // dispatch(getTripData(testObj))
  }, [dispatch]);

  if (!isEmpty(tripStateData)) {
    isLoading = false;
    console.log("Success: Trip found", tripStateData);
    localStorage.setItem("tripId", tripStateData.item_id);
    localStorage.setItem("metaData", tripStateData.display_name);
    navigate("/triplanding");
  } else {
    console.log("Error : No Trip found", tripStateData);
    navigate("/error");
  }

  return <></>;
}
